import { Table } from "antd";
import Manage from "..";
import { useContext, useEffect, useState } from "react";
import DeleteBoooking from "./components/DeleteBoooking";
import CreateBooking from "./components/CreateBooking";
import ConfirmBooking from "./components/ConfirmBooking";
import Moment from "react-moment";
import { formatNumber } from "../../../utils/formatNumber";
import { BsCalendar2Check, BsCheckSquare } from "react-icons/bs";
import Toastify from "toastify-js";
import UpdateWip from "./components/UpdateWip";
import { IoAdd, IoTrashBinOutline } from "react-icons/io5";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import RescheduleBooking from "./components/RescheduleBooking";
import { AiOutlineEye } from "react-icons/ai";
import DetailsPanel from "./components/DetailsPanel";
import { GoLocation } from "react-icons/go";
import { pusher } from "../../..";
import BookingHeader from "./components/BookingHeader";
import moment from "moment";
import UpdateCode from "./components/UpdateCode";

export default function AllBookings() {
  const { user, token, expire } = useContext(AuthContext);
  const [createModal, setCreateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [wipModal, setWipModal] = useState(false);
  const [codeModal, setCodeModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [bookings, setBookings] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showPanel, setShowPanel] = useState(false);

  const [site, setSite] = useState<any>(user?.site);
  const [dates, setDates] = useState<any>({
    startDate: moment(new Date()),
    endDate: moment(new Date()),
    isRange: false,
  });

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `bookings/smart/${site?._id}?start=${moment(
      dates?.startDate
    ).format("YYYYMMDD")}&end=${moment(dates?.endDate).format(
      "YYYYMMDD"
    )}&all=0`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchBookings();
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  const handleReFetchBookings = async ({ range }: any) => {
    setLoading(true);
    let uri = `bookings/smart/${site?._id}?start=${moment(
      range?.startDate
    ).format("YYYYMMDD")}&end=${moment(range?.endDate).format(
      "YYYYMMDD"
    )}&all=${range?.isAll ? 1 : 0}`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  const handleDateChange = async ({ range }: any) => {
    handleReFetchBookings({ range });
  };

  const handleSiteChange = async ({ site, range }: any) => {
    setSite(site);
    handleReFetchBookings({ range });
  };

  const columns: any = [
    {
      title: "S/N",
      width: 50,
      dataIndex: "",
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 250,
      dataIndex: "",
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 p-2 w-full truncate">
              <span className="mr-2"> Guest:</span>

              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          ) : (
            <div className="p-2 truncate">
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Vehicle",
      width: 110,
      dataIndex: "",
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.vehicle === null ? "-" : record?.vehicle}
        </div>
      ),
    },
    {
      title: "Model",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.model_year === null ? "" : record?.model_year}{" "}
          {record?.model === null ? "-" : record?.model}
        </div>
      ),
    },
    {
      title: "Service",
      width: 160,
      dataIndex: "",
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.description === null ? "-" : record?.description}
        </div>
      ),
    },

    {
      title: "Mileage (Km)",
      width: 110,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mileage === null || record?.mileage === ""
            ? "-"
            : formatNumber(Number(record?.mileage))}
        </span>
      ),
    },

    {
      title: "Date",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.date}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Time",
      width: 180,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.slottime === null ? (
            "-"
          ) : (
            <>
              <Moment format="HH:mm A">{record?.slottime?.starttime}</Moment>
              <span className="mx-2">-</span>
              <Moment format="HH:mm A">{record?.slottime?.endtime}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Center",
      width: 160,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <GoLocation />
          <div className="ml-1 truncate">
            {record?.site?.name ? record?.site?.name : "-"}
          </div>
        </div>
      ),
    },
    {
      title: "Booking No.",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.bookingno ? record?.bookingno : "-"}
          </span>
        </div>
      ),
    },
    {
      title: "WIP",
      width: 60,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.wip ? (
              record?.wip
            ) : (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setWipModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-gray-100 hover:bg-gray-200 cursor-pointer"
              >
                <IoAdd /> WIP
              </button>
            )}
          </span>
        </div>
      ),
    },
    {
      title: "Promo Code",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.promo_code ? (
              record?.promo_code
            ) : (
              <button
                onClick={() => {
                  setSelected({
                    ...record,
                  });
                  setCodeModal(true);
                }}
                className="flex justify-center items-center text-gray-700 border rounded-md px-2 py-1 bg-gray-100 hover:bg-gray-200 cursor-pointer"
              >
                <IoAdd /> CODE
              </button>
            )}
          </span>
        </div>
      ),
    },

    {
      title: "Assigned To",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <span className="ml-1">
            {record?.assignedTo
              ? `${record?.assignedTo?.firstname.charAt(0)}.${
                  record?.assignedTo?.lastname
                }`
              : "-"}
          </span>
        </div>
      ),
    },
    {
      title: "Reschedule",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setRescheduleModal(true);
            }}
            className="flex justify-center items-center ml-1 text-yellow-700 border rounded-md px-2 py-1 bg-yellow-50 hover:bg-yellow-50"
          >
            <BsCalendar2Check /> <span className="ml-1">Reschedule</span>
          </button>
        </div>
      ),
    },
    {
      title: "Status",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          {record.is_confirmed ? (
            <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md px-2 py-1 bg-green-100 hover:bg-green-200 cursor-not-allowed">
              <BsCheckSquare /> <span className="ml-1">Confirmed</span>
            </button>
          ) : (
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setConfirmModal(true);
              }}
              className="flex justify-center items-center text-red-700 border rounded-md px-2 py-1 bg-gray-100 hover:bg-gray-200 cursor-pointer"
            >
              <span className="ml-1">Unconfirmed </span>
            </button>
          )}
        </div>
      ),
    },
    {
      title: "Details",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setShowPanel(true);
            }}
            className="flex justify-center items-center ml-1 text-blue-700 border rounded-md px-2 py-1 bg-blue-50 hover:bg-blue-50"
          >
            <AiOutlineEye /> <span className="ml-1">Details</span>
          </button>
        </div>
      ),
    },
    {
      title: "Delete",
      width: 70,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md px-2 py-1 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"Bookings"}
      subtitle={"Recent"}
      hasLogo={true}
      description={"List of recent bookings"}
      actions={<></>}
    >
      <BookingHeader
        bookings={bookings}
        inManage={true}
        site={site}
        stateHandler={handleDateChange}
        siteHandler={handleSiteChange}
        handleFetchBookings={handleFetchBookings}
      />
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            columns={columns}
            dataSource={bookings}
            size="small"
            pagination={{ pageSize: 20 }}
            scroll={{ y: 625 }}
            rowKey="id"
            loading={isLoading}
          />

          <CreateBooking
            isVisible={createModal}
            setCreateModal={setCreateModal}
          />

          <ConfirmBooking
            selected={selected}
            isVisible={confirmModal}
            setConfirmModal={setConfirmModal}
            handleFetchBookings={handleFetchBookings}
          />

          <RescheduleBooking
            selected={selected}
            isVisible={rescheduleModal}
            setConfirmModal={setRescheduleModal}
            refetch={handleFetchBookings}
          />

          <UpdateWip
            selected={selected}
            isVisible={wipModal}
            setVisible={setWipModal}
            handleFetchBookings={handleFetchBookings}
          />

          <UpdateCode
            selected={selected}
            isVisible={codeModal}
            setVisible={setCodeModal}
            handleFetchBookings={handleFetchBookings}
          />

          <DeleteBoooking
            selected={selected}
            isVisible={deleteModal}
            setVisible={setDeleteModal}
            refetch={handleFetchBookings}
          />

          <DetailsPanel
            isVisible={showPanel}
            setVisible={setShowPanel}
            selected={selected}
          />
        </div>
      </div>
    </Manage>
  );
}
